import './App.css';
import Header from './components/Header';
import Project from './components/Project';

function App() {
  return (
    <>
      <Header/>
      <Project />
    </>
  );
}

export default App;
